import React from "react";
import { Container, Row, Col, Card, ListGroup, Button, Badge } from "react-bootstrap";

import "./login.css";
import { useLang } from "../../contexts/LanguageContext";
import freeIcon from "../../images/pricing_paper_airplane.svg";
import premiumIcon from "../../images/pricing_diamont.svg";

const planIcons = {
  free: freeIcon,
  premium: premiumIcon,
};

export default function PricingPlans({
  plans = [],
  onSelectPlan = () => {},
  showHeader = true,
}) {
  const { t } = useLang();

  return (
    <Container className="p-40 m-0 princing-board">
      {showHeader && (
        <div className="text-center mb-4">
          <h2 className="fw-bold">{t("PRICING_HEADER_TITLE")}</h2>
          <p className="text-muted">{t("PRICING_HEADER_SUBTITLE")}</p>
        </div>
      )}

      <Row className="g-4 justify-content-center">
        {plans.map((plan) => {
          const iconSrc = planIcons[plan.id];

          return (
            <Col key={plan.id} xs={12} md={6} lg={5} className="d-flex justify-content-center">
              <Card
                className={`h-100 border-5 shadow-sm border-${
                  plan.highlight ? plan.highlight : "light"
                }`}
              >
                <Card.Body className="d-flex flex-column">

                  <Card.Title as="h3" className="gap-3">
                    {iconSrc && <img src={iconSrc} alt={plan.name} className="plan-icon" />}
                    {plan.name}
                  </Card.Title>
                  <Card.Text className="text-muted">{plan.description}</Card.Text>
                  {plan.price && (
                    <div className="mb-2">
                      <h4 className="d-inline">{plan.price}</h4>{" "}
                      {plan.period && (
                        <small className="text-muted">/{plan.period}</small>
                      )}
                    </div>
                  )}
                  {plan.note && <small className="text-muted">{plan.note}</small>}

                  <ListGroup variant="flush" className="mt-3 flex-grow-1">
                    {plan.features.map((f, i) => (
                      <ListGroup.Item key={i}>{f}</ListGroup.Item>
                    ))}
                  </ListGroup>

                  <div className="mt-auto pt-3">
                    <Button
                      variant={plan.buttonVariant || "outline-primary"}
                      className="w-100 princing-button"
                      onClick={() => onSelectPlan(plan.id)}
                    >
                      {plan.buttonText}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>

      {showHeader && (
        <div className="text-center mt-4">
          <small className="text-muted">{t("PRICING_FOOTER_NOTE")}</small>
        </div>
      )}
    </Container>
  );
}
